import useCacheQuery, { CacheQueryOpts, CacheQueryOutput } from "modules/core/services/query/hooks/useCacheQuery";
import TransportLocation from "../types/TransportLocation";
import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import {TransportEnum} from "../enums/TransferTransportEnum";

type Output = TransportLocation[];

export default function useTransLocationsGetCollectByTransportAndCityId (
    transport?: TransportEnum | null,
    city?: string,
    options?: CacheQueryOpts
): CacheQueryOutput<Output> {
    const client = useAPIClient();
    
    return useCacheQuery<Output>(
        ["transport-locations", transport, city],
        () => {
            return client.get<any>(`transport_locations`, {
                transport: transport,
                city: city,
            });
        },
        options
    );
}

